<template>
  <div>
    <table border="1" frame="void" rules="rows">
      <thead>
        <template v-if="definition.headings">
          <tr class="top-header">
            <th
              v-for="(header, rIndex) in definition.headings"
              :key="rIndex"
              scope="col"
            >
              {{ header }}
            </th>
          </tr>
        </template>
      </thead>
      <tbody v-if="hasTableData">
        <tr v-for="(row, rIndex) in definition.values" :key="rIndex">
          <td v-for="(cell, cIndex) in row" :key="cIndex">
            {{ cell.text }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'AscTable',

  props: {
    definition: {
      type: Object,
      required: true,
    },
  },

  computed: {
    hasTableData() {
      return (
        this.definition.values !== undefined &&
        this.definition.values.length > 0
      )
    },
  },
}
</script>

<style lang="scss" scoped>
table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  text-align: left;
  border: 1px solid $gray-400;
}

table td {
  border: 0;
}

table th,
table td {
  padding: 0.5em;
  font-size: $font-size-sm;
}

table th {
  background-color: $gray-0;
  font-weight: normal;
  border-collapse: collapse;
  border: 1px solid $gray-400;
}
</style>
